function renderWishlistCounter(swat) {
  var counterElems = document.querySelectorAll('.swym-wishlist-header-counter');

  if (!counterElems || !counterElems.length) {
    return;
  }

  for (var i = 0; i < counterElems.length; i++) {
    if (swat && swat.renderWishlistCount) {
      swat.renderWishlistCount(
        counterElems[i],
        function (count, element) {
          // wishlist count rendered
        }
      );
    }
  }
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(renderWishlistCounter);
